
import { createHmac, pbkdf2Sync } from "node:crypto";
import { Buffer } from "buffer";

export function hmacSha512(key: Uint8Array, data: Uint8Array): Buffer {
    return createHmac("sha512", key).update(data).digest();
}

export function pbkdf2Sha512(
    password: Uint8Array,
    salt: Uint8Array,
    iterations: number,
    dkLen: number
): Buffer {
    return pbkdf2Sync(password, salt, iterations, dkLen, "sha512");
}
